// @flow

import type { PendingIncomingPayment } from './types';

export function getSafeQrisQRCode(incomingPayment: PendingIncomingPayment): string {
  const qris = incomingPayment['qris'];
  if(!qris){
    throw new Error('Qris: no qris data in incoming payment');
  }
  const qrisQRCode = qris['qr_code_value'];
  if(!qrisQRCode){
    throw new Error('Qris: no QR Code in incoming payment');
  }
  return qrisQRCode;
}
